import { Button } from '@customink/pigment-react';
import { FC, useCallback } from 'react';
import { useNotifications } from '~/contexts/NotificationContext';
import { useCreateTaxExemptionPortal } from '~/adapters/services/accounts/tax-exemptions/hooks';
import setLocationNewTab from '~/adapters/browser/setLocationNewTab';
import Spinner from '~/components/Spinner';
import { PWC } from '~/adapters/typescript/propsWithChildren';

export const TaxExemptionsCreatePortalButton: FC<PWC> = ({ children }) => {
    const { pushApiErrorNotification } = useNotifications();

    const { mutate: createNewPortal, isLoading: isCreatingPortal } = useCreateTaxExemptionPortal();

    const handleClick = useCallback(
        () =>
            createNewPortal(undefined, {
                onSuccess: (data) => setLocationNewTab(data.portalUrl),
                onError: () => pushApiErrorNotification('Something went wrong.'),
            }),
        [createNewPortal],
    );

    return (
        <Button startIcon={isCreatingPortal ? <Spinner /> : null} onClick={handleClick} disabled={isCreatingPortal}>
            {children}
        </Button>
    );
};
